<template>
  <div>
    <v-sheet class="py-0 px-1">
      <v-chip-group center-active show-arrows>
        <v-chip
          v-for="(item, i) in subCategories"
          :key="i"
          :color="$route.query.subcategory == item._id ? appColor : '#3e4a4d'"
          @click="changeRoute(item)"
        >
          <span
            style="
              font-family: poppinssemibold;
              font-size: 12px;
              color: #ffffff;
              letter-spacing: 2px;
            "
          >
            {{ item.name }}
          </span>
        </v-chip>
      </v-chip-group>
    </v-sheet>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      subCategories: [],
    };
  },
  beforeMount() {
    this.getSubCategory();
  },
  methods: {
    getSubCategory() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/me",
        headers: {
         token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.subCategories = response.data.data.sellerid.subcategory
          // this.subCategories = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },

    changeRoute(item) {
      this.$router.push({
        path: "/Seller/Inventory",
        query: {
          subcategory:
            this.$route.query.subcategory != item._id ? item._id : null,
          searchKey: this.$route.query.searchKey,
          sub: item.name
        },
      });
    },
  },
};
</script>